export const countryCodes = [
    { id: 'CA', label: 'CA' },
    { id: 'CH', label: 'CH' },
    { id: 'DE', label: 'DE' },
    { id: 'DK', label: 'DK' },
    { id: 'FI', label: 'FI' },
    { id: 'FR', label: 'FR' },
    { id: 'GB', label: 'GB' },
    { id: 'IT', label: 'IT' },
    { id: 'LI', label: 'LI' },
    { id: 'LU', label: 'LU' },
    { id: 'MT', label: 'MT' },
    { id: 'NO', label: 'NO' },
    { id: 'PL', label: 'PL' },
    { id: 'SE', label: 'SE' },
    { id: 'US', label: 'US' },
]

export const countryCodesKeyValuePairs = {
    CA: { id: 'CA', label: 'CA' },
    CH: { id: 'CH', label: 'CH' },
    DE: { id: 'DE', label: 'DE' },
    DK: { id: 'DK', label: 'DK' },
    FI: { id: 'FI', label: 'FI' },
    FR: { id: 'FR', label: 'FR' },
    GB: { id: 'GB', label: 'GB' },
    IT: { id: 'IT', label: 'IT' },
    LI: { id: 'LI', label: 'LI' },
    LU: { id: 'LU', label: 'LU' },
    MT: { id: 'MT', label: 'MT' },
    NO: { id: 'NO', label: 'NO' },
    PL: { id: 'PL', label: 'PL' },
    SE: { id: 'SE', label: 'SE' },
    US: { id: 'US', label: 'US' },
} as const

export const currencies = [
    { id: 'SEK', label: 'SEK' },
    { id: 'EUR', label: 'EUR' },
    { id: 'DKK', label: 'DKK' },
    { id: 'NOK', label: 'NOK' },
] as const

export const currenciesKeyValuePairs = {
    SEK: { id: 'SEK', label: 'SEK' },
    EUR: { id: 'EUR', label: 'EUR' },
    DKK: { id: 'DKK', label: 'DKK' },
    NOK: { id: 'NOK', label: 'NOK' },
} as const
